import moment from 'moment/moment';
import StringUtils from '../utils/StringUtils';
import BaseServiceCrud from './BaseServiceCrud';
import Constants from '../utils/constants';

export default class PayrollEntryService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'payroll-entry';
    }
    getCriteria(criteria) {
        return this.objToQueryString({
            full_name: criteria.fullName,
            contract_type: criteria.contractType?.enumValue,
            date: StringUtils.isBlank(criteria.date)
                ? moment(new Date()).format(Constants.DATE_GET_REQUEST_FORMAT)
                : moment(criteria.date).format(Constants.DATE_GET_REQUEST_FORMAT),
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    exportList(criteria) {
        const params = this.getCriteria(criteria);
        return this.fetch(
            `${this.domain}/${this.path}/export${params}`,
            {
                method: 'POST',
            },
            {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            }
        )
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }
}
